import { FieldDef } from './fields'
import { getKey } from './public-view'

const map: {
  [key: number]: {
    name: string
    variant: 'success' | 'processing' | 'default' | 'error' | 'warning'
  }
} = {
  [1]: { name: 'Opublikowany', variant: 'success' },
  [2]: { name: 'Szkic', variant: 'processing' },
  [3]: { name: 'Archiwalny', variant: 'default' },
}

export const getStatuses = () => {
  let statuses: { label: string; value: number }[] = []
  for (const key in map) {
    if (map.hasOwnProperty(key)) {
      statuses.push({ label: map[key].name, value: parseInt(key, 10) })
    }
  }

  return statuses
}

export const getStatus = (
  status: number,
): 'success' | 'processing' | 'default' | 'error' | 'warning' => {
  if (map.hasOwnProperty(status)) {
    return map[status].variant
  }
  return 'error'
}

export const getStatusName = (status: number): string => {
  if (map.hasOwnProperty(status)) {
    return map[status].name
  }
  return 'error'
}

export const formikErrorsToArr = (
  errors: {
    [key: string]: string
  },
  fields: FieldDef[],
): string[] => {
  let ret: string[] = []
  for (const p in errors) {
    if (errors.hasOwnProperty(p)) {
      const foundField = fields.filter((el, i) => {
        const fieldKey = getKey(i)
        return fieldKey == p
      })

      const msg =
        foundField.length > 0
          ? `${foundField[0].label}: ${errors[p]}`
          : `${errors[p]}`
      ret.push(msg)
    }
  }

  return ret
}
